// src/redux/pdfSlice.js

import { createSlice } from '@reduxjs/toolkit';

const anonymizationSlice = createSlice({
  name: 'anonymization',
  initialState: {
    publicationConfirmationHidden: false,
    documentBuffer: null
  },
  reducers: {
    setPublicationConfirmationHidden: (state, action) => {
      state.publicationConfirmationHidden = action.payload;
    },
    setDocumentBuffer: (state, action) => {
      state.documentBuffer = action.payload;
    }
  }
});

export const { setPublicationConfirmationHidden, setDocumentBuffer } = anonymizationSlice.actions;

export default anonymizationSlice.reducer;
